import React, { useState } from "react";

import { Box, Tooltip, IconButton, Typography } from "@material-ui/core";
import {
  FileCopy as ContentCopyIcon,
  Visibility,
  VisibilityOff,
} from "@material-ui/icons";
export const sensorNameList = {
  VXLicensedCounterSensors: "Licensed Counter Sensors",
  GSFloodSensors: "Flood Sensors",
  VXDotSensors: "DOT Sensors",
};

export const statusList = {
  all: { label: "All", color: "default" },
  AvailableUnassignedSensors: { label: "Unassigned", color: "default" },
  OtherAssignedSensors: {
    label: "Assigned (Other Facilities)",
    color: "warning",
  },
  RequestedAssignedSensors: {
    label: "Assigned (Current Facility)",
    color: "primary",
  },
};

export function CopyableId({ id, label, icon = false, sx }) {
  const [copied, setCopied] = useState(false);
  const [showFullId, setShowFullId] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(id);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Failed to copy ID:", err);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleCopy();
    }
  };

  const shortId = id?.slice(-6) ?? "";
  const idText = `#${shortId}`;
  const displayText = label ? `${label} : ${idText}` : idText;

  return (
    <Box
      component="span"
      className="commonsize"
      role="button"
      tabIndex={0}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        ...sx,
      }}
    >
      <Tooltip title={showFullId ? "Show Short ID" : "Show Complete ID"} arrow>
        <IconButton size="small" onClick={() => setShowFullId((r) => !r)}>
          {showFullId ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </Tooltip>
      {icon && (
        <Tooltip title={copied ? "Copied!" : "Click to copy"} arrow>
          <IconButton
            size="small"
            onClick={handleCopy}
            onKeyDown={handleKeyDown}
          >
            <ContentCopyIcon
              fontSize="inherit"
              style={{ color: copied ? "success.main" : "inherit" }}
            />
          </IconButton>
        </Tooltip>
      )}
      <Typography component="span" variant="inherit">
        {showFullId ? id : displayText}
      </Typography>
    </Box>
  );
}
